module.exports = __webpack_public_path__ + "img/logo_ariall_srl.4286a80d.png";